<template>
    <main class="main-container">
        <top-head></top-head>
        <side-nav :navShow.sync="navShow"></side-nav>
        <section class="wrapper" :class="{'collpase':!navShow}">
            <router-view></router-view>
        </section>
    </main>
</template>
<script>
import topHead from '@/components/layout/header.vue'
import sideNav from '@/components/layout/sidenav.vue'
export default {
    components: { topHead, sideNav },
    data() {
        return {
            navShow: true
        }
    },
    async beforeRouteEnter(to,from,next){
        next()
    }
}
</script>
<style scoped lang="scss">
.main-container {
    width: 100%;
    padding-top: 40px;
}

.wrapper {
    padding-left: 140px;
    transition: all .4s ease;
    min-width:1000px;
    &.collpase {
        padding-left: 54px;
    }

}
</style>
